import { render, staticRenderFns } from "./InstanceNoData.vue?vue&type=template&id=30770f6c&scoped=true"
import script from "./InstanceNoData.vue?vue&type=script&lang=js"
export * from "./InstanceNoData.vue?vue&type=script&lang=js"
import style0 from "./InstanceNoData.vue?vue&type=style&index=0&id=30770f6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30770f6c",
  null
  
)

export default component.exports